import { useAuth } from '@/context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/common';

export function LoginPage() {
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const location = useLocation();

  // Redirect if already authenticated
  if (isAuthenticated) {
    const from = (location.state as { from?: Location })?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-primary-600 to-primary-800 px-4">
      <div className="w-full max-w-sm">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <div className="w-24 h-24 rounded-2xl overflow-hidden bg-black flex items-center justify-center mx-auto mb-4 shadow-lg">
            <img
              src="https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780705705/logo_DRCC_fondo_negro_1_bjhzxt.jpg"
              alt="DR Company California"
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1 tracking-wide">REFERIDOS CALIENTES</h1>
          <p className="text-primary-100">DR Company California</p>
          <p className="text-xs text-primary-200 mt-1 italic">Inspirado por Romar Silvestre</p>
        </div>

        {/* Login card */}
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <h2 className="text-lg font-semibold text-gray-900 text-center mb-4">
            Inicia Sesión
          </h2>

          <p className="text-sm text-gray-600 text-center mb-6">
            Usa tu cuenta de Google para acceder al sistema
          </p>

          {error && (
            <div className="bg-danger-50 text-danger-700 p-3 rounded-lg text-sm mb-4">
              {error}
            </div>
          )}

          <Button
            onClick={login}
            loading={isLoading}
            className="w-full"
            icon={
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
            }
          >
            Continuar con Google
          </Button>

          <p className="text-xs text-gray-500 text-center mt-4">
            Al iniciar sesión, aceptas que tus datos se utilicen únicamente para
            el funcionamiento del sistema.
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-primary-200 text-center mt-6">
          © {new Date().getFullYear()} DR Company California. Todos los derechos reservados.
        </p>
      </div>
    </div>
  );
}
